module.exports = __webpack_public_path__ + "img/money-1.50dd0fa4.png";